import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeleteSectionCondition = () => {
  const { authHeader } = useAuth();

  return useMutation((id: any) => {
    return axios.post(`${env.verifyServiceUrl}individual/section_condition/bulk_delete/`, id, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
